<ng-container *ngIf="shouldShowStars()">
  <app-benchmark-stars
    [max]="max"
    [score]="score"
    [efficiency]="efficiency"
  ></app-benchmark-stars>
</ng-container>
